var map = {
	"./AdminBuilder": 75,
	"./AdminBuilder.js": 75,
	"./PageRender": 91,
	"./PageRender.js": 91,
	"./admin/ImagePicker": 92,
	"./admin/ImagePicker.js": 92,
	"./admin/MenuEditor": 93,
	"./admin/MenuEditor.js": 93,
	"./admin/TableBuilder": 55,
	"./admin/TableBuilder.js": 55,
	"./frontend/Button": 5,
	"./frontend/Button.js": 5,
	"./frontend/EmergencyNotice": 66,
	"./frontend/EmergencyNotice.js": 66,
	"./frontend/LanguageSwitcher": 20,
	"./frontend/LanguageSwitcher.js": 20,
	"./frontend/Layout": 19,
	"./frontend/Layout.js": 19,
	"./frontend/Modal": 15,
	"./frontend/Modal.js": 15,
	"./frontend/SiteFooter": 31,
	"./frontend/SiteFooter.js": 31,
	"./frontend/SiteHeader": 30,
	"./frontend/SiteHeader.js": 30,
	"./providers/LanguagesContext": 12,
	"./providers/LanguagesContext/": 12,
	"./providers/LanguagesContext/LanguagesContext": 23,
	"./providers/LanguagesContext/LanguagesContext.js": 23,
	"./providers/LanguagesContext/index": 12,
	"./providers/LanguagesContext/index.js": 12,
	"./utils/http": 53,
	"./utils/http.js": 53,
	"./widgets": 14,
	"./widgets/": 14,
	"./widgets/CardsCarouselWidget": 56,
	"./widgets/CardsCarouselWidget.js": 56,
	"./widgets/CardsWidget": 46,
	"./widgets/CardsWidget.js": 46,
	"./widgets/ContactFormWidget/ContactFormWidget": 60,
	"./widgets/ContactFormWidget/ContactFormWidget.js": 60,
	"./widgets/ContactFormWidget/Input": 18,
	"./widgets/ContactFormWidget/Input.js": 18,
	"./widgets/ContactFormWidget/Textarea": 52,
	"./widgets/ContactFormWidget/Textarea.js": 52,
	"./widgets/CtaAccentWidget": 39,
	"./widgets/CtaAccentWidget.js": 39,
	"./widgets/CtaWidget": 38,
	"./widgets/CtaWidget.js": 38,
	"./widgets/FeaturesWidget": 41,
	"./widgets/FeaturesWidget.js": 41,
	"./widgets/GalleryWidget": 59,
	"./widgets/GalleryWidget.js": 59,
	"./widgets/HeroWidget": 50,
	"./widgets/HeroWidget.js": 50,
	"./widgets/HtmlWidget": 36,
	"./widgets/HtmlWidget.js": 36,
	"./widgets/IntroParagraphWidget": 40,
	"./widgets/IntroParagraphWidget.js": 40,
	"./widgets/LeadImageWidget": 37,
	"./widgets/LeadImageWidget.js": 37,
	"./widgets/LeadVideoWidget": 47,
	"./widgets/LeadVideoWidget.js": 47,
	"./widgets/LogoCarouselWidget": 51,
	"./widgets/LogoCarouselWidget.js": 51,
	"./widgets/LogosWidget": 48,
	"./widgets/LogosWidget.js": 48,
	"./widgets/MosaicCardsWidget": 45,
	"./widgets/MosaicCardsWidget.js": 45,
	"./widgets/NavigationWidget": 35,
	"./widgets/NavigationWidget.js": 35,
	"./widgets/ReferenceSliderWidget": 58,
	"./widgets/ReferenceSliderWidget.js": 58,
	"./widgets/ReferenceWidget": 57,
	"./widgets/ReferenceWidget.js": 57,
	"./widgets/SectionTitleWidget": 32,
	"./widgets/SectionTitleWidget.js": 32,
	"./widgets/SingleImageWidget": 33,
	"./widgets/SingleImageWidget.js": 33,
	"./widgets/SpotlightWidget": 42,
	"./widgets/SpotlightWidget.js": 42,
	"./widgets/StatsWidget": 44,
	"./widgets/StatsWidget.js": 44,
	"./widgets/StepsWidget": 43,
	"./widgets/StepsWidget.js": 43,
	"./widgets/TableWidget": 54,
	"./widgets/TableWidget.js": 54,
	"./widgets/TestimonialWidget": 49,
	"./widgets/TestimonialWidget.js": 49,
	"./widgets/TextBoxWidget": 34,
	"./widgets/TextBoxWidget.js": 34,
	"./widgets/index": 14,
	"./widgets/index.js": 14
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;